import React, { useState } from "react"
import { Box, CssBaseline } from "@mui/material"
import { Outlet } from "react-router-dom"
import Navbar from "./Navbar"
import Sidebar from "./Sidebar"

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      <Navbar toggleSidebar={toggleSidebar} />
      <Box
        component="main"
        sx={{
          display: "flex",
          flexDirection: "column",
          transition: "all 0.3s ease",
          boxShadow: "2",
          bgcolor: "background.paper",
          py: 4,
          pl: { xs: 1, md: 3 },
          ml: { xs: 0, md: 2 },
          mt: "64px",
          borderTopLeftRadius: { xs: 0, md: 16 },
          width: "100%",
          height: "calc(100vh - 64px)",
        }}
      >
        <Box sx={{ flex: 1, overflow: "auto", width: "100%" }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
